import {useProducts} from '@salesforce/commerce-sdk-react'

const DEFAULT_STALE_TIME = 5 * 60 * 1000

/**
 * Fetches products by their IDs and returns them as a map keyed by product id.
 *
 * @param {string} productIds - Comma-separated product IDs
 * @param {Object} [queryOptions] - React Query options
 * @param {boolean} [queryOptions.enabled=true] - Additional enabled condition (ANDed with a productIds check)
 * @param {number} [queryOptions.staleTime] - Stale time in ms
 * @returns {Object} The useProducts query result, where data is an id-keyed map
 */
export const useProductsById = (productIds, queryOptions = {}) => {
    const {enabled = true, staleTime = DEFAULT_STALE_TIME} = queryOptions

    return useProducts(
        {
            parameters: {
                ids: productIds,
                allImages: false
            }
        },
        {
            enabled: Boolean(productIds) && enabled,
            staleTime,
            select: (result) => {
                // Convert array into key/value object with key is the product id
                return result?.data?.reduce((acc, item) => {
                    acc[item.id] = item
                    return acc
                }, {})
            }
        }
    )
}
